import moment, { Moment } from "moment";

export class DateTime {
  protected static readonly DEFAULT_TIME_DURATION_FORMAT = "HH:mm:ss";

  // This currently works only if the duration
  // string is as given in the format
  // DateTime::DEFAULT_TIME_DURATION_FORMAT
  static getDurationAsUtc(dateTimeStr: string): Moment {
    return moment.utc(`1970-01-01T${dateTimeStr}+00:00`);
  }

  // Calculate elapsed time
  static getDifferenceAsUtc(
    startTime: Moment,
    endTime: Moment,
    durationUnit: any = "seconds",
  ): Moment {
    return moment.utc(
      moment
        .duration(endTime.diff(startTime, durationUnit), durationUnit)
        .asMilliseconds(),
    );
  }

  // This currently works only for the format
  // DateTime::DEFAULT_TIME_DURATION_FORMAT
  static getFormattedDuration(dateTime: Moment): string {
    return dateTime.format(DateTime.defaultTimeDurationFormat);
  }

  // Getters and setters
  static get defaultTimeDurationFormat() {
    return DateTime.DEFAULT_TIME_DURATION_FORMAT;
  }
}



// WEBPACK FOOTER //
// ./src/helpers/datetime.ts